import { ShoppingCartOutlined } from "@mui/icons-material"
import { Badge, Button, styled, type BadgeProps, type SxProps } from "@mui/material"
import type { Currency } from "../../models/currency"
import type { ValuesOf } from "../../models/enums"
import { Money } from "./money"
import { useStore } from "ra-core"
import { useAccount, useOrder, useOrderItem } from "../../hooks"
import type { order_item } from "../../models"

interface AddProps {
    id: string;
    amount: number;
    currency: ValuesOf<typeof Currency>;
    sx?: SxProps;
}

export const Add = ({ id, amount, currency, sx = {} }: AddProps) => {
    const [orderId] = useStore<number>("orderId");
    const { id: buyerId } = useAccount();
    const [sellerId, offerId, variantId] = id.split("-").map(x => Number.parseInt(x, 10));
    const order = useOrder({ sellerId, buyerId, orderId });
    const [quantity, setQuantity] = useOrderItem({
        orderId,
        sellerId,
        buyerId,
        variantId,
        itemId: offerId,
        quantity: order?.details.find(x => x.itemId === offerId && x.variantId === variantId)?.quantity ?? 0,
    } as unknown as order_item);
    return <Button 
            variant="contained"
            sx={() => ({'& .MuiButton-endIcon': { margin: 0 },
                height: 48, 
                width: 90, 
                borderBottomLeftRadius: 0,
                borderTopRightRadius: 0,
                boxShadow: "var(--mui-shadows-2)",
                ...sx as any
            })} 
            color="secondary"
            aria-label="Add to cart"
            onClick={() => {
                setQuantity(quantity + 1);
            }}
            endIcon={<>
                {/* <Box sx={t => ({
                    height: 48,
                    width: 90,
                    backgroundColor: t.palette.primary.light,
                    position: "absolute",
                    left: 0,
                    clipPath: "polygon(50% -5%, 105% 50%, 50% 105%, 70% 50%);"
                    })} 
                /> */}
                <Money 
                    amount={amount} 
                    currency={currency} 
                    sx={{ height: 48, zIndex: 1 }}>
                        <StyledBadge anchorOrigin={{ horizontal: "left" }} badgeContent={quantity} color="primary">
                            <ShoppingCartOutlined sx={{ fontSize: "1.3rem" }} />
                        </StyledBadge>
                </Money>
            </>
            }
        />;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ }) => ({
  '& .MuiBadge-badge': {
    minWidth: 14,
    height: 14,
    width: 16
  },
}));